import { Container, Divider, Spacer } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'

const LoaderCard = memo(() => (
    <Container className="mb-4">
        <Container className="br-16 pt-4 w-100p ba-solid" css={{ borderColor: '#e6e6e6' }}>
            <Container className="flex flex-between flex-middle px-4">
                <Container className="flex flex-middle">
                    <Container>
                        <Stencil shimmer height="32px" width="32px" className="br-8" />
                    </Container>
                    <Spacer className="ml-2" />
                    <Container>
                        <Stencil shimmer height="14px" width="62px" className="br-2" />
                        <Spacer className="mb-1" />
                        <Stencil shimmer height="14px" width="62px" className="br-2" />
                    </Container>
                </Container>
                <Container width="220px" className="ml-12 pl-13">
                    <Stencil shimmer height="30px" width="220px" className="br-2" />
                </Container>
                <Container width="120px" className="ml-12 pl-13">
                    <Stencil shimmer height="40px" width="120px" className="br-2" />
                </Container>
            </Container>
            <Container className="mt-3 mb-3 px-4">
                <Stencil shimmer height="20px" width="88px" className="br-2" />
            </Container>
        </Container>
    </Container>
))

function OnewayTuppleLoaderFF() {
    return (
        <Container className="mt-6">
            <LoaderCard />
            <LoaderCard />
            <LoaderCard />
            <LoaderCard />
            <LoaderCard />
            <LoaderCard />
        </Container>
    )
}

export default OnewayTuppleLoaderFF
